<template>
  <div id="image-upload-quiz">
    <div :class="isChoice ? 'uploader-container-choice' : 'uploader-container'">
      <div class="d-flex">
        <div
          :style="renderImageUrl"
          :class="`${vertical ? 'image-area-vertical' : 'image-area'} ${
            uploadImage.url ? 'preview-image' : null
          } ${isChoice ? 'image-upload-choice' : 'image-area'} ${
            isImageLarge
              ? uploadImage.url
                ? 'image-large'
                : 'image-upload-choice'
              : ''
          }`"
          @click="onUpload"
          class="upload-image"
        >
          <div v-if="!uploadImage.url" class="replace-upload">
            <div class="d-flex justifly-content-center">
              <div><icon-upload class="icon-upload mr-2" /></div>
              <div>Upload</div>
            </div>
          </div>
          <div v-if="uploadImage.url" class="replace-upload">
            <div class="d-flex justifly-content-center">
              <div><icon-upload class="icon-upload mr-2" /></div>
              <div>Replace</div>
            </div>
          </div>
        </div>
        <div class="ml-2" v-if="removable">
          <icon-trash
            class="w-100 icon-delete-image"
            @click.native="handleDelete"
          />
        </div>
      </div>

      <input
        ref="refInputEl"
        type="file"
        class="d-none"
        :accept="acceptFile.toString()"
        @change="handleUploadChange"
      />
      <div
        class="d-flex flex-wrap upload-button-container mt-1"
        :class="
          expectedWidth || expectedHight
            ? 'justify-content-between'
            : 'justify-content-end'
        "
      >
        <div v-if="expectedWidth || expectedHight">
          <div class="scale-container" v-if="expectedWidth">
            <span class="scale-label">{{ "W" }}</span>
            <span>{{ `: ${expectedWidth} pixel` }}</span>
          </div>
          <div class="scale-container" v-if="expectedHight">
            <span class="scale-label">{{ "H" }}</span>
            <span>{{ `: ${expectedHight} pixel` }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconTrash from "@/@core/components/svg/common/IconTrash.vue";
import IconUpload from "@/@core/components/svg/common/IconUpload.vue";
import useImageUpload from "../hooks/useImageUpload";
export default {
  components: { IconTrash, IconUpload },
  props: {
    imageUrl: String,
    removable: { type: Boolean, default: false },
    pillButton: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    expectedWidth: { type: Number },
    expectedHight: { type: Number },
    acceptFile: {
      type: [String, Array],
      default: () => [".jpg", ".jpeg", ".png"],
    },
    isChoice: { type: Boolean, default: false },
    isRequired: { type: Boolean, default: false },
    isImageLarge: { type: Boolean, default: false },
  },

  setup(props) {
    const {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    } = useImageUpload(props);

    return {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/image-upload.css";
</style>
